module.exports = __webpack_public_path__ + "img/218.missing_paper.8b51caaf.svg";